import { render } from "./StoryReport.vue?vue&type=template&id=86f7e252&scoped=true"
import script from "./StoryReport.vue?vue&type=script&lang=js"
export * from "./StoryReport.vue?vue&type=script&lang=js"

import "./StoryReport.vue?vue&type=style&index=0&id=86f7e252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f7e252"]])

export default __exports__